export const createSectionFormProxy = (source, update) =>
  new Proxy(
    {},
    {
      get: (_target, field) => source()?.[field],
      set: (_target, field, value) => {
        update({ field, value });
        return true;
      },
    }
  );
